export const actionTypes = {
  //auth
  LOGIN_ACTION: 'LOGIN',
  EDIT_PROFILE_ACTION: 'EDIT_PROFILE',
  LOGOUT_ACTION: 'LOGOUT',

  //commom fetch done
  FETCH_DONE_ACTION: 'FETCH_DONE',

  //course
  LOAD_COURSES_ACTION: 'LOAD_COURSES',
  ADD_COURSE_ACTION: 'ADD_COURSE',

  //enrolment
  LOAD_ENROLMENTS_ACTION: 'LOAD_ENROLMENTS',
  ENROL_COURSE_ACTION: 'ENROL_COURSE',
  SET_ENROLCOUNT_ACTION: 'SET_ENROLCOUNT',
  GET_ENROLCOUNT_ACTION: 'FETCH_ENROLCOUNT',

  //notification
  PRESSED_NOTIFICATION_ACTION: 'PRESSED_NOTIFICATION',
  LOAD_NOTIFICATIONS_ACTION: 'LOAD_NOTIFICATIONS',
  SET_UNCHECKED_NOTIFICATION_COUNT_ACTION: 'SET_UNCHECKED_NOTIFICATION_COUNT',

  //face photo
  LOAD_FACE_PHOTOS_ACTION: 'LOAD_FACE_PHOTOS',

  //attendace
  LOAD_ATTENDANCES_ACTION: 'LOAD_ATTENDANCES',
  ADD_ATTENDANCE_ACTION: 'ADD_ATTENDANCE',
  RESET_STATE_ACTION: 'RESET_STATE',
};
